import React, { useContext } from "react";
import style from "./index.module.scss";
import Editor from "components/Editor";
import { findOneValue, TopicsItem } from "../../../../../service";
import { QuestionnaireContext } from "../../../../../store";

interface SubjectiveProps {
    index?: number;
    data: TopicsItem;
    oneSave: (questionId: string, value: string) => void;
    oneChange: (questionId: string, value: string) => void;
}

export default function PageSubjective({
    data,
    oneSave,
    oneChange,
    index
}: SubjectiveProps) {
    const { questionnaire } = useContext(QuestionnaireContext);
    const value = findOneValue(data.id, questionnaire) || data.stuAns;

    function onBlur(val: string) {
        oneSave(data.id, val);
    }

    function onChange(val: string) {
        oneChange(data.id, val);
    }

    return (
        <div className={style.root} key={data.id}>
            <div className={style.top}>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（主观题）</span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
            </div>

            <div className={style.options}>
                <div className={style.optionsTip}>
                    您的回答<span className={style.tips}>(请在下方作答)</span>
                </div>
                {<Editor data={value} onBlur={onBlur} onChange={onChange} />}
            </div>
        </div>
    );
}
